module.exports = __webpack_public_path__ + "static/media/ChatNotification.33bc5262.mp3";